<template>
    <modal v-if="show"
           size="xl"
           :show="show"
           :id="utils.randomId({prefix: 'modal'})"
           @close="close()">
        <template #title>
            Create Teams
        </template>

        <div class="teams-wrap" ref="teams">
            <div class="teams">
                <div class="team" v-for="team in teams" :key="team.id">
                    <div class="inner">
                        <div class="form-group">
                            <label>Team Name</label>
                            <input type="text"
                                   v-model="team.name"
                                   class="form-control"
                                   placeholder="Team Name">
                        </div>
                        <div class="form-group">
                            <label>Students</label>
                            <textarea type="text"
                                      v-model="team.students"
                                      class="form-control"
                                      rows="8"
                                      :placeholder="`Copy paste one student per line. For example:\nKathy P\nJohn T`"></textarea>
                        </div>
                    </div>
                </div>
                <div class="team add-new">
                    <div class="inner" @click="addBlankTeam()">
                        <span>+</span>
                        Add New
                    </div>
                </div>
            </div>
        </div>

        <template #footer>
            <button class="btn btn-warning"
                    :disabled="is_busy"
                    @click="close()">Cancel</button>

            <state-button class="btn btn-primary ml-auto"
                          :disabled="is_busy"
                          :state="is_busy ? 'busy' : ''"
                          @click="createTeams()">Create Teams</state-button>
        </template>
    </modal>
</template>

<script>
import Modal from "@/Components/Common/Modal";
import utils from "@/mixins/utils";
import jQuery from "jquery";
import API from "@/API";
import StateButton from "@/Components/Common/StateButton";

export default {
    name: "AddTeamModal",
    components: {StateButton, Modal},
    mixins: [utils],
    emits: ['teams-added', 'close'],
    props: ['project', 'show'],


    data(){
        return {
            is_busy: false,
            teams: [],
        }
    },


    methods: {

        addBlankTeam(autoScroll = true){
            this.teams.push({
                id: this.utils.randomId({prefix: 't'}),
                name: '',
                students: '',
            });

            if( autoScroll ){
                const $teams = jQuery( this.$refs.teams );
                $teams.animate({ scrollLeft: $teams[0].scrollWidth }, 300);
            }

        },

        async createTeams(){
            this.is_busy = true;
            try{
                const teams = await API.teams.createBulk(this.project.id, this.teams);
                this.$emit('teams-added', teams);
            }catch (e) { }
            this.is_busy = false;
        },

        close(){
            this.$emit('close');
        }

    },

    mounted() {
        this.addBlankTeam(false);
    }

}
</script>

<style lang="scss" scoped>

.teams-wrap{
    overflow: auto;
    padding: 1rem 0;
}

.teams{
    display: flex;
    align-items: stretch;
    margin-left: -.5rem;
    margin-right: -.5rem;
}

.team{
    display: flex;
    width: 320px;
    flex: 0 0 320px;
    padding-left: .5rem;
    padding-right: .5rem;


    textarea{
        min-height: 320px;
    }
}

.inner{
    flex: 1 1 100%;
    width: 100%;
    padding: 1rem;
    background: rgba(black, 0.1);
    border-radius: 0.5rem;
}

.add-new{

    .inner{
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        color: lighten($dark, 30%);
        cursor: pointer;

        &:hover{
            span{
                background: $primary;
            }
        }

        span{
            font-size: 3rem;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 5rem;
            height: 5rem;
            background: rgba($dark, 0.1);
            border-radius: 50%;
            margin-bottom: 1rem;
            color: white;
        }
    }

}

</style>
